import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export default function WhoWeAre() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 grid lg:grid-cols-2 gap-16 items-center">
        <div className="relative">
          <div className="absolute -top-6 -left-6 w-32 h-32 border-4 border-fx-gold rounded-md hidden lg:block" />
          <div className="absolute -bottom-6 -right-6 w-40 h-40 bg-fx-cream rounded-md hidden lg:block" />
          <div className="relative rounded-lg overflow-hidden shadow-xl">
            <img src="https://images.unsplash.com/photo-1638262052640-82e94d64664a?w=1200&q=80" alt="Foxstone partnership" className="w-full h-[460px] object-cover" />
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-fx-gold font-semibold">Who We Are</p>
          <h2 className="font-display text-4xl lg:text-5xl text-fx-navy font-bold mt-3">Foxstone is changing the landscape</h2>
          <div className="fx-section-divider mt-5" />
          <p className="mt-6 text-slate-700 leading-relaxed">
            Foxstone Funding is an independent equipment finance brokerage. We provide equipment leasing solutions and working capital loans to businesses across Canada.
          </p>
          <p className="mt-4 text-slate-700 leading-relaxed">
            Your business needs are constantly changing — you need a finance partner that evolves with you. Foxstone helps you secure the equipment and capital required to grow, quickly and hassle-free.
          </p>

          <Button asChild className="mt-8 bg-fx-navy hover:bg-fx-navy-deep text-white rounded-sm h-12 px-7">
            <Link to="/about">About Foxstone <ArrowRight className="w-4 h-4 ml-2" /></Link>
          </Button>
        </div>
      </div>
    </section>
  );
}
